import { Component, Input } from '@angular/core';
import { getDoodLogoWhiteUrl } from '@common/i18n/dood-logo-url';
import { getDoodBrand } from '@common/i18n/get-dood-brand';

@Component({
  selector: 'app-legals-footer-block',
  templateUrl: './legals-footer-block.component.html',
})
export class LegalsFooterBlockComponent {
  @Input() links: unknown[] = [];
  @Input() displayPoweredByDood = true;

  protected readonly doodLogo = getDoodLogoWhiteUrl();
  protected readonly doodBrand = getDoodBrand();

  hasLinks(): boolean {
    return Array.isArray(this.links) && this.links.length > 0;
  }
}
